export const buildMatchTypesQueryString = (matchTypesArray) => matchTypesArray.map(x => "matchTypes" + "=" + x).join("&");

const customerAppraiserExclusions = {
  add() {
    return `/CustomerAppraiserExclusions`;
  },
  remove(exclusionId) {
    return `/CustomerAppraiserExclusions/${exclusionId}`;
  },
  getCustomers(appraiserNumber) {
    return `/CustomerAppraiserExclusions/appraisers/${appraiserNumber}`;
  },
  getAppraisers(customerNumber) {
    return `/CustomerAppraiserExclusions/customers/${customerNumber}`;
  },
  findAppraisers(customerNumber, matchTypesArray) {
    return `/CustomerAppraiserExclusions/customers/${customerNumber}/search?${buildMatchTypesQueryString(matchTypesArray)}`;
  },
};

export default customerAppraiserExclusions;